export default "__VITE_ASSET__2571152c__"